import { Component, Inject, Input, OnInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CrimeDataService } from '../crime-log/crime-data.service';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Agency } from '../agency';
import { CrimeType, Disposition, CrimeSubType, Crime } from '../crime';
import { Site } from '../site';
import { BatsConfirmComponent } from '../lib/bats-confirm/bats-confirm.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-crime-log-form',
  templateUrl: './crime-log-form.component.html',
  styleUrls: ['./crime-log-form.component.scss']
})
export class CrimeLogFormComponent implements OnInit {
  @Input() public crime = new Crime();
  @Input() public nocrime;
  @Input() public sitecode;
  @Input() public reportNumbers: number[];

  public editMode =  false;

  agencyList: Agency[];
  crimeTypeList: CrimeType[];
  crimeSubTypeList: CrimeSubType[];
  dispList: Disposition[];
  sites: Site[];
  numberOfReports: number = 0;

  crimeForm = this.fb.group({
    SITECODE: ['S900000001'],
    AGENCY_ID: [''],
    REPORT_NUMBER: [''],
    REPORT_DATE: [''],
    LOG_DATE: ['', Validators.required],
    CRIME_TYPE: ['', Validators.required],
    CRIME_TYPE_SUB: [''],
    CRIME_TYPE_UPDATED: [false],
    DISPOSITION_UPDATED: [false],
    CRIME_START: [''],
    CRIME_END: [''],
    LOCATION: [''],
    BUILDING: [''],
    DISPOSITION_ID: [''],
    INCIDENT_COUNT: [''],
    ID: [''],
    COPY: [false],
  });


  constructor(public dialogRef: MatDialogRef<CrimeLogFormComponent>,
              private crimeDataService: CrimeDataService,
              private fb: FormBuilder,
              @Inject(MAT_DIALOG_DATA) public data: Site[],
              private modalService: NgbModal) { }

  ngOnInit() {
    this.reportNumbers = this.data['reportNumbers'];
    this.sites = this.data['siteList'];
    this.loadAgencies();
    this.loadDisposition();
    this.loadCrimeTypes();
    this.loadCrimeSubTypes();

    if (this.crime.ID !== undefined) {
      this.editMode = true;
      this.crimeForm.get('SITECODE').setValue(this.crime.SITECODE);
      this.crimeForm.get('ID').setValue(this.crime.ID);
      this.crimeForm.get('AGENCY_ID').setValue(this.crime.AGENCY_ID);
      this.crimeForm.get('REPORT_NUMBER').setValue(this.crime.REPORT_NUMBER);
      this.crimeForm.get('REPORT_DATE').setValue(new Date(this.crime.REPORT_DATE));
      this.crimeForm.get('LOG_DATE').setValue(new Date(this.crime.LOG_DATE + "T23:59:00"));
      this.crimeForm.get('CRIME_TYPE').setValue((this.crime.CRIME_TYPE.substring(0,1) != '*') ? this.crime.CRIME_TYPE : this.crime.CRIME_TYPE.substring(1));
      this.crimeForm.get('CRIME_TYPE_SUB').setValue(this.crime.CRIME_TYPE_SUB);
      /*this.crimeForm.get('CRIME_START').setValue(this.crime.CRIME_START);
      this.crimeForm.get('CRIME_END').setValue(this.crime.CRIME_END);*/
      this.crimeForm.get('CRIME_START').setValue(new Date(this.crime.CRIME_START));
      this.crimeForm.get('CRIME_END').setValue(new Date(this.crime.CRIME_END));
      this.crimeForm.get('LOCATION').setValue(this.crime.LOCATION);
      this.crimeForm.get('DISPOSITION_ID').setValue(this.crime.DISPOSITION_ID);
      this.crimeForm.get('DISPOSITION_UPDATED').setValue(this.crime.DISPOSITION_UPDATED);
      this.crimeForm.get('CRIME_TYPE_UPDATED').setValue(this.crime.CRIME_TYPE_UPDATED);
      this.crimeForm.get('INCIDENT_COUNT').setValue(this.crime.INCIDENT_COUNT);
    }

    this.crimeForm.controls.BUILDING.valueChanges.subscribe(e => (e?.BUILDING_NAME && this.crimeForm.controls.LOCATION.setValue(`${e.ADDRESS1}, ${e.CITY}`)))
    this.crimeForm.controls.REPORT_NUMBER.valueChanges.subscribe(e=>{
        this.numberOfReports  = this.reportNumbers.filter(x => e == x).length;
    })
  }

  closeDialog() {
    this.dialogRef.close('closed');
  }// end closeDialog

  deleteCrime() {
    const modalRef = this.modalService.open(BatsConfirmComponent)
     modalRef.result.then((result : any) => {
      this.crimeDataService.deleteCrime(this.crime.ID).subscribe(() => this.closeDialog());
    },
    (reason: any) => {
      return false;
    });
  }// end deleteCrime
  loadData(arg0: boolean) {
    throw new Error('Method not implemented.');
  }

  copyCrime(){
    this.editMode = false;
    this.crimeForm.get('COPY').setValue(true);
    this.crimeForm.get('REPORT_DATE').setValue(new Date(this.crimeForm.value.REPORT_DATE));
    this.crimeForm.get('CRIME_START').setValue(new Date(this.crimeForm.value.CRIME_START));
    this.crimeForm.get('CRIME_END').setValue(new Date(this.crimeForm.value.CRIME_END));
    this.crimeForm.get('LOG_DATE').setValue(new Date(this.crimeForm.value.LOG_DATE));
  }

  loadAgencies() {
    this.crimeDataService.getAgencies()
    .subscribe(agencyList => this.agencyList = agencyList);
  }// end loadAgencies

  loadCrimeTypes() {
    this.crimeDataService.getCrimeTypes()
    .subscribe(crimeTypeList => this.crimeTypeList = crimeTypeList);
  }// end loadAgencies

  loadCrimeSubTypes() {
    this.crimeDataService.getCrimeSubTypes()
    .subscribe(crimeSubTypeList => this.crimeSubTypeList = crimeSubTypeList);
  }// end loadAgencies

  loadDisposition() {
    this.crimeDataService.getDispositions()
    .subscribe(dispList => this.dispList = dispList);
  }// end loadDisposition

  checkType(): boolean {
    if (this.crimeForm.value.CRIME_TYPE.substring(0,10) == 'Hate Crime') {
      return true;
    } else {
      return false;
    }
  }

  onSubmit() {
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    function setCrimeDates(dateObject, ie, trim){
      //var date = '';
      var dateString = '';
      if(ie){
        //date = dateObject.toLocaleString('en-US',{ hour12: false });
        var month = (dateObject.getMonth() < 9) ? '0'+ (dateObject.getMonth() + 1) :   dateObject.getMonth()+ 1;
        var day = (dateObject.getDate() < 10) ? '0'+ dateObject.getDate() : dateObject.getDate();
        var hours = (dateObject.getHours() < 10) ? '0'+ dateObject.getHours() : dateObject.getHours();
        var minutes = (dateObject.getMinutes() < 10) ? '0'+ dateObject.getMinutes() : dateObject.getMinutes();
        dateString = dateObject.getFullYear() + '-' + month + '-' + day + 'T' + hours + ':' + minutes;

      }
      else{
        var date = dateObject.toLocaleString('en-US',{ hourCycle: 'h23' }) + " UTC";
        var dateNonUTC = new Date(date);
        dateString = dateNonUTC.toISOString();
      }

      dateString = dateString.substring(0,trim);
      return dateString;
    }

    this.crimeForm.value.CRIME_START = (this.crimeForm.value.CRIME_START) ? setCrimeDates(this.crimeForm.value.CRIME_START, isIEOrEdge,16) : "";
    this.crimeForm.value.REPORT_DATE = (this.crimeForm.value.REPORT_DATE) ? setCrimeDates(this.crimeForm.value.REPORT_DATE, isIEOrEdge,16) : "";
    this.crimeForm.value.CRIME_END = (this.crimeForm.value.CRIME_END) ? setCrimeDates(this.crimeForm.value.CRIME_END, isIEOrEdge,16) : "";
    this.crimeForm.value.LOG_DATE = (this.crimeForm.value.LOG_DATE) ? setCrimeDates(this.crimeForm.value.LOG_DATE, isIEOrEdge,10) : "";
    if(this.crimeForm.value.COPY){
      this.crimeForm.value.ID = "";
    }

    //this.crimeForm.get('crimeTypeUpdated;)

    // TODO: Use EventEmitter with form value
    if (this.editMode) {
      this.crimeDataService.saveCrime(this.crimeForm.value)
      .subscribe(() => this.closeDialog());
    } else {
      this.crimeDataService.addCrime(this.crimeForm.value)
      .subscribe(() => this.closeDialog());
    }
  }// end onSubmit

}
